import { Box, useTheme } from "@mui/material";

function DotsLoader({ size = 20 }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: size,
        height: size,
        // background: theme.palette.background.light,
        borderRadius: "50%",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        filter: "grayscale(1)",
        opacity: 0.7,
      }}
    >
      <img
        src={"/images/loaders/loading_dots.gif"}
        alt="meta"
        style={{
          width: size,
          height: size,
          display: "block",
        }}
      />
    </Box>
  );
}

export default DotsLoader;
